/**
 * File stax-accordion.js
 *
 * Handles accordion toggles.
 *
 * Uses event delegation to listen to clicks on existing and future dynamically
 * created accordion toggles, such as are found on the dictionary page.
 *
 * Provides a "toggle all" function which can toggle all accordions within the
 * parent div of the target element
 */
let load = () => {
	const accordionBtns = document.querySelectorAll(".accordion");
	if (!accordionBtns.length) return;

	// individual accordions
	document.querySelector("#primary").addEventListener("click", function ({ target }) {
		const accordion = target.closest(".accordion");
		if (!accordion) return;

		accordion.classList.toggle("is-open");
		let content = accordion.nextElementSibling;
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
		} else {
			content.style.maxHeight = content.scrollHeight + "px";
		}
	});

	// bulk toggle
	document.querySelector("#primary").addEventListener("click", function (e) {
		const toggle = e.target.closest("[class$=toggle-all]");
		if (!toggle) return;

		e.preventDefault();

		const accordions = Array.from(toggle.closest("div").querySelectorAll(".accordion"));
		const expand = () => {
			toggle.textContent = "Collapse All";
			accordions.forEach((accordion) => {
				accordion.classList.add("is-open");
				const content = accordion.nextElementSibling;
				content.style.maxHeight = content.scrollHeight + "px";
			});
		};
		const collapse = () => {
			toggle.textContent = "Expand All";
			accordions.forEach((accordion) => {
				accordion.classList.remove("is-open");
				accordion.nextElementSibling.style.maxHeight = null;
			});
		};

		if (toggle.textContent === "Expand All") expand();
		else collapse();
	});
};

document.addEventListener("DOMContentLoaded", function () {
	load();
});
